import React, { useState } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import ScriptType from './ScriptType';

export default function NewScriptPopup({ onClose, onConfirm, scripts }) {
  const [name, setName] = useState('');
  const [type, setType] = useState('ND');

  function validName() {
    return (
      name.trim().length > 0 &&
      !scripts.map(script => script.name.toLowerCase()).includes(name.toLowerCase())
    );
  }

  function validType() {
    return type !== 'ND';
  }

  return (
    <Modal show>
      <Modal.Header>
        <Modal.Title>Create new script</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={e => e.preventDefault()}>
          <Form.Group>
            <Col as={Form.Label} sm={4}>
              Script name
            </Col>
            <Col sm={8}>
              <Form.Control
                size="sm"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                isInvalid={validName() ? false : true}
              />
            </Col>
          </Form.Group>
          <Form.Group>
            <Col as={Form.Label} sm={4}>
              Type
            </Col>
            <Col sm={8}>
              <Form.Control
                size="sm"
                as="select"
                value={type}
                onChange={e => setType(e.target.value)}
              >
                <option disabled value="ND">
                  select type
                </option>
                <option value={ScriptType.MORPHING}>EXAM MORPHING (forwarding)</option>
                <option value={ScriptType.INSTANCE_MORPHING}>INSTANCE MORPHING (storing or forwarding)</option>
                <option value={ScriptType.SERVLET}>SERVLET</option>
                <option value={ScriptType.TIMER}>TIMER</option>
                <option value={ScriptType.COOL_DOWN}>COOL DOWN</option>
                <option value={ScriptType.FILE_HANDLER}>FILE HANDLER</option>
                <option value={ScriptType.FORWARD_FILTER}>FORWARD FILTER</option>
                <option value={ScriptType.WORKLIST}>WORKLIST</option>
              </Form.Control>
            </Col>
            <Col as={Form.Label} sm={12}>
              <p className="form-text">{getHelp(type)}</p>
            </Col>
          </Form.Group>
        </Form>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!validName() || !validType()}
            onClick={e => {
              const data = {
                name,
                type,
              };
              onConfirm(data);
            }}
          >
            Create
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function getHelp(type) {
  switch (type) {
    case ScriptType.MORPHING:
      return 'Can be assigned to a forward rule. Used to change patient or study level metadata of outgoing studies';
    case ScriptType.INSTANCE_MORPHING:
      return 'Can be assigned to a node or a forward rule. Used to change metadata of incoming or forwarding instances';
    case ScriptType.SERVLET:
      return 'Called on incoming HTTP requests to /script/{SCRIPT_NAME}';
    case ScriptType.TIMER:
      return 'Called regularly. Must be configured in Timers section';
    case ScriptType.COOL_DOWN:
      return 'Called when a study cools down';
    case ScriptType.FILE_HANDLER:
      return 'Called when a new file is detected inside a watched folder';
    case ScriptType.FORWARD_FILTER:
      return 'Called for each forwarded instance (if configured). Can be used to filter out some instances';
    case ScriptType.WORKLIST:
      return 'Called when sending worklist results from a worklist node';
    default:
      return '';
  }
}
